/**
 * 全局颜色变量
 * 定义应用中使用的所有颜色，支持亮色和暗色主题
 */

// 主要品牌颜色 - 适用于两种主题的不变颜色
export const brandColors = {
  // Airbnb 风格主色
  red: '#FF5A5F',
  teal: '#00A699',
  purple: '#7B0051',
  orange: '#FF8C38',
  
  // 状态颜色
  success: '#008489',
  warning: '#FFB400',
  info: '#428BCA',
  error: '#FF5A5F',
};

// 亮色主题颜色
export const lightColors = {
  // 背景
  background: {
    primary: '#FFFFFF',
    secondary: '#F5F5F5',
    tertiary: '#FAFAFA',
  },
  
  // 文本
  text: {
    primary: '#484848',
    secondary: '#767676',
    tertiary: '#999999',
    inverted: '#FFFFFF',
  },
  
  // 边框和分隔线
  border: {
    light: '#EBEBEB',
    medium: '#DDDDDD',
    dark: '#CCCCCC',
  },
  
  // 交互元素
  interactive: {
    hover: 'rgba(0, 0, 0, 0.05)',
    active: 'rgba(0, 0, 0, 0.1)',
    focus: 'rgba(255, 90, 95, 0.2)',
  },
  
  // 卡片和容器
  surface: {
    primary: '#FFFFFF',
    secondary: '#F8F8F8',
    tertiary: '#F2F2F2',
  },
  
  // 阴影
  shadow: {
    light: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 6px 20px rgba(0, 0, 0, 0.2)',
  },
};

// 暗色主题颜色
export const darkColors = {
  // 背景
  background: {
    primary: '#1C1C1E', // iOS 深色模式背景色
    secondary: '#2C2C2E', // iOS 深色模式次要背景色
    tertiary: '#3A3A3C', // iOS 深色模式第三级背景色
  },
  
  // 文本
  text: {
    primary: '#FFFFFF',
    secondary: '#EBEBEB',
    tertiary: '#ACACAE',
    inverted: '#484848',
  },
  
  // 边框和分隔线
  border: {
    light: '#3A3A3C',
    medium: '#4E4E50',
    dark: '#636366',
  },
  
  // 交互元素
  interactive: {
    hover: 'rgba(255, 255, 255, 0.1)',
    active: 'rgba(255, 255, 255, 0.15)',
    focus: 'rgba(255, 90, 95, 0.3)',
  },
  
  // 卡片和容器
  surface: {
    primary: '#2C2C2E',
    secondary: '#3A3A3C',
    tertiary: '#48484A',
  },
  
  // 阴影
  shadow: {
    light: '0 2px 4px rgba(0, 0, 0, 0.3)',
    medium: '0 6px 20px rgba(0, 0, 0, 0.4)',
  },
};

// 根据主题合并颜色集合，便于使用
export const getThemedColors = (theme: 'light' | 'dark') => {
  return {
    ...brandColors,
    ...(theme === 'light' ? lightColors : darkColors),
  };
}; 